import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
	},
	error: {
		color: THEME.colors.danger.main,
		fontSize: THEME.typography.fontSizes.sm,
		margin: 0,
	},
	frame: {
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		boxSizing: 'border-box',
		flex: 1,
		minHeight: 0,
		overflow: 'hidden',
		width: '100%',
	},
	linkIcon: {
		height: SPACE[16],
		width: SPACE[16],
	},
	linkRow: {
		flex: 'none',
		paddingTop: SPACE[8],
	},
});
